import React from 'react';
import Box from 'components/react-styled-core/Box';

import Loader from './Loader';

const AppLoader = () => (
    <Box
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
    >
        <Loader size="lg"/>
    </Box>
);

export default AppLoader;
